module.exports = function(data) {
var __t, __p = '';
__p += '<h5>' +
((__t = ( strings.saveFiltersEmptyHeader )) == null ? '' : __t) +
'</h5>\n<ol>\n    <li>' +
((__t = ( strings.saveFiltersEmptyStep1 )) == null ? '' : __t) +
'</li>\n    <li>' +
((__t = ( strings.saveFiltersEmptyStep2 )) == null ? '' : __t) +
'</li>\n</ol>';
return __p
}